import React from 'react';
import { connect } from 'dva';
import { Form, Input, Radio, Icon, Button, Checkbox, DatePicker, Select, Row, Col } from 'antd';
import FormComponent from '../../../components/FormComponent';
import Dimio from '../../../components/Dimio';
import config from '../config/config';

const {fields, setApi} = config.contact;

/**
 * contact
 *   .type  enquiry type [school|visa]
 */

class ContactFormBase extends FormComponent {
  constructor(props) {
    super(props);

    this.state = {
      readTC: false,
      subType: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectSubtype = this.selectSubtype.bind(this);
  }
  /*
  componentWillMount() {
    console.info('contact.type', this.props.contact.type);
  }
  */

  componentDidMount() {
    const {contact, form} = this.props;

//    console.info(contact);
//    console.info(contact.test);

    let init = {
      school_inspection: 'no',
    };

    if(contact.test == 1){
      init = {
        email: contact.email,
        name: contact.name,
        phone: contact.phone,
        enquiry: 'Test Enquiry'
      };
    }
    if(form) {
      form.setFieldsValue(init);
    }
  }

  selectSubtype(e) {
    this.setState({subType: e.target.value});
  }

  handleSubmit(e) {
    e.preventDefault();

    const {form, contact, selected } = this.props;
    const self = this;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.showLoading();

        const _data = values;
        _data.test = contact.test;
        if(values.type === undefined){
          _data.type = contact.type;
        }
//        _data.contactType = contact.contactType;
//        _data.contactType = contact.type;   // temporary sending
        _data.contact_type = contact.type;  //

        if(values.counselling_date) {
          _data.counselling_date = values.counselling_date.format("YYYY-MM-DD");
        }
        if(selected) {
          _data.selected = selected;
        }

        _data.url = window.location.href;
//        console.info(_data);
        this.save(setApi, {
          data: _data,
          onSuccess(res){
            console.info(res);
            self.hideError();

            window.location.href = "/school/school-thankyou?from="+self.state.subType
          },
          onError(err){
            self.showError(err.message);
          }
        });
      }
    });
  }

  render() {
    const Field = this.Field;
    const Submit = this.Submit;
    const { contact } = this.props;
    const {subType} = this.state;

    const SchoolPlugin = () => (
      <div>
        {contact.type === 'school' &&
        <Field {...fields.sub_type} options={{initialValue:'school'}}>
          <Radio.Group onChange={this.selectSubtype}>
            {fields.sub_type.items.map(item => (
              <Radio.Button value={item.value} key={item.value}><Icon type={item.icon}/> {item.label}</Radio.Button>
            ))}
          </Radio.Group>
        </Field>
        }

        {subType == 'visa' &&
        <Row>
          <Col sm={12} xs={24}>
            <Field {...fields.counselling_date}>
              <DatePicker />
            </Field>
          </Col>
          <Col sm={12} xs={24}>
            <Field {...fields.counselling_time}>
              <Select>
                {fields.counselling_time.items.map(item => (
                  <Select.Option value={item.key} key={item.key}>{item.label}</Select.Option>
                ))}
              </Select>
            </Field>
          </Col>
        </Row>
        }
      </div>
    )

    return (
      <Form onSubmit={this.handleSubmit}>
        <section>
          {contact.type === 'school' &&
            <SchoolPlugin/>
          }

          <Field {...fields.name}>
            <Input placeholder={fields.name.label} />
          </Field>
          <Field {...fields.email}>
            <Input placeholder={fields.email.label} type="email" />
          </Field>
          <Field {...fields.phone}>
            <Input placeholder={fields.phone.ph} type="tel" />
          </Field>
          <div className="form-note">
            <small><span className="text-danger">※</span> お急ぎの方は電話番号とその旨を明記いただければ電話にて対応させていただきます。</small>
          </div>
          <Field {...fields.enquiry}>
            <Input.TextArea rows={3} />
          </Field>
        </section>

        <Submit className='btn btn-success btn-block'>この内容で送信する</Submit>
      </Form>
    );
  }
}

const ContactForm = Form.create()(ContactFormBase);

export default connect(({ contact }) => ({
  contact
}))(ContactForm);
//export default ContactForm;



// WEBPACK FOOTER //
// ./src/pages/contact/components/ContactForm.js